import axios from 'axios';
import { AuthResponse, MultipleEventsResponse, RSVPUpdateRequest, RSVPUpdateResponse } from '../types';

// const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const API_BASE_URL = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const rsvpApi = {
  async authenticate(phone: string, accessCode: string): Promise<AuthResponse | MultipleEventsResponse> {
    const response = await api.post('/api/rsvp/auth', {
      phone,
      accessCode,
    });
    return response.data;
  },

  async updateRSVP(data: RSVPUpdateRequest): Promise<RSVPUpdateResponse> {
    const response = await api.put('/api/rsvp/update', data);
    return response.data;
  },

  async requestMembership(data: { name: string; phone: string; note?: string; hostId?: string }): Promise<any> {
    const response = await api.post('/api/membership-requests', data);
    return response.data;
  },
};

export default api;